// REMIX HMR BEGIN
import * as __hmr__ from "remix:hmr";
if (import.meta) {
import.meta.hot = __hmr__.createHotContext(
//@ts-expect-error
"app\\components\\shared\\BookingForm\\index.ts"
);
import.meta.hot.lastModified = "1757171103351.3674";
}
// REMIX HMR END

export { BookingForm } from "./BookingForm";